import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Container, CardGroup } from "react-bootstrap";
import ComponentSousTitle from "../../layout/ComponentSousTitle";
import { apiGetEmissions } from "../../../api/ApiEmission";
import ComponentEmissionsThumbnail from "./ComponentEmissionsThumbnail";
import ComponentLoader from "../../layout/ComponentLoader";

const BlocEmissionsThumbnail = (props) => {
  const { t } = useTranslation();
  const { type } = props;
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [emissions, setEmissions] = useState([]);
  const [loader, SetLoader] = useState(false);

  const recupVideos = async () => {
    SetLoader(true);
    let filter = "emission";
    if (type === "podcast") filter = "podcast";

    const res = await apiGetEmissions(
      ReduxInstance._id,
      "filter[type]=" + filter + "&sort[ordre]=-1"
    );

    if (res.data[0]) {
      setEmissions(res.data);
    } else {
      setEmissions([]);
    }
    SetLoader(false);
  };

  useEffect(() => {
    recupVideos();
  }, [ReduxInstance]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {ReduxInstance.modulesActives.includes("emission") &&
        emissions.filter((item) => item.publie === true).length > 0 && (
          <Container className="mt-5" fluid>
            {type === "emission" ? (
              <ComponentSousTitle
                nom={t("public.filtres.filtre12")}
                overflowID={"overflowEmissions"}
                overflowDeplieAuDepart={true}
              />
            ) : (
              <ComponentSousTitle
                nom={t("public.filtres.filtre13")}
                overflowID={"overflowPodcasts"}
              />
            )}

            {loader && (
              <div className="text-center">
                <ComponentLoader />
              </div>
            )}
            {!loader && (
              <CardGroup
                className="disableOverflowContent"
                id={type === "emission" ? "overflowEmissions" : "overflowPodcasts"}
              >
                {emissions
                  .filter((item) => item.publie === true)
                  .map((emission, index) => (
                    <ComponentEmissionsThumbnail emissionObject={emission} key={index} />
                  ))}
              </CardGroup>
            )}
          </Container>
        )}
    </>
  );
};

export default BlocEmissionsThumbnail;
